function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function convertPythonTimestampToJsTimestamp(timestamp) {
  if (typeof timestamp !== 'number') {
    console.warn('Invalid timestamp: ', timestamp);
    return null;
  }
  return timestamp * 1000;
}

export { convertPythonTimestampToJsTimestamp, getTimezone };
